import {
  BanditosDailyBonus,
  CashFrenzyDailyBonus,
  DrimageDailyBonus,
  EDailyBonusInternalViewModel,
  JunesJourneyDailyBonus,
  RectangleDailyBonus,
  SpinxDailyBonus,
  SquareDailyBonus
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const square: BlockMetadata = {
  id: EDailyBonusInternalViewModel.SQUARE,
  version: '1.0.0',
  name: '1:1 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/popup_square.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: SquareDailyBonus
};

const rectangle: BlockMetadata = {
  id: EDailyBonusInternalViewModel.RECTANGLE,
  version: '1.0.0',
  name: '2:3 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/popup_rectangle.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: RectangleDailyBonus
};

const defaultJunesJourney: BlockMetadata = {
  id: EDailyBonusInternalViewModel.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/junes-journey-popup.png'
  ],
  theme: EThemes.JUNES_JOURNEY,
  component: JunesJourneyDailyBonus
};

const defaultBanditos: BlockMetadata = {
  id: EDailyBonusInternalViewModel.BANDITOS,
  version: '1.0.0',
  name: 'Banditos',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [''],
  theme: EThemes.BANDITOS,
  component: BanditosDailyBonus
};

const defaultSpinX: BlockMetadata = {
  id: EDailyBonusInternalViewModel.SPIN_X,
  version: '1.0.0',
  name: 'Spin X',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [''],
  theme: EThemes.SPIN_X,
  component: SpinxDailyBonus
};

const defaultCashFrenzy: BlockMetadata = {
  id: EDailyBonusInternalViewModel.CASH_FRENZY,
  version: '1.0.0',
  name: 'Cash Frenzy',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [''],
  theme: EThemes.CASH_FRENZY,
  component: CashFrenzyDailyBonus
};

const defaultDrimage: BlockMetadata = {
  id: EDailyBonusInternalViewModel.DRIMAGE,
  version: '1.0.0',
  name: 'Drimage',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [''],
  theme: EThemes.DRIMAGE,
  component: DrimageDailyBonus
};

export const popupDesigns = {
  defaultJunesJourney,
  defaultBanditos,
  defaultSpinX,
  defaultCashFrenzy,
  defaultDrimage,
  square,
  rectangle
};
